<script setup>
import { CloseBold } from "@element-plus/icons-vue"
import { ref } from "vue";
import { storeToRefs } from "pinia";
import conditions from "./conditions.vue";
import { useMailLogStore} from "../stores/maillog";

const store = useMailLogStore();
const filters = ref([]);
const props = defineProps([ 'closeClick',]);

const filterRelation = [
    {
        value: 'and', label: 'AND', icon: ''
    },
    {
        value: 'or', label: 'OR', icon: ''
    },
];

const addFilter = (e) => {
    filters.value= [
        ...filters.value,
        {
            filter: '',
            key: '',
            operator: 'LIKE',
            value: '',
        }
    ];
   
}

const removeFilter = (e,id) => {
    filters.value = filters.value.filter((filter, i) => i !== id);
}

const applyFilter = (e) => {
    store.setFilters(filters.value);
    store.fetchLogs();
}
</script>

<template>
    <div class="wml-filters-wrapper" style="position: relative;">
        <el-icon class="wml-close-filter" @click="closeClick"><CloseBold /></el-icon>
        <el-row class="wml-filter-row">
            <el-col :span="2">
                Filter Relation
            </el-col>
            <el-col :span="2">
                <el-select v-model="store.filterRelation" placeholder="OR">
                    <el-option
                        v-for="item in filterRelation"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
            </el-col>
        </el-row>
        <conditions v-for="(filter,index) in filters" :filterData="filter" :key="index" :removeFilter="removeFilter" :id="index" />
        
        <el-button @click="addFilter" :icon="Plus" >Add Filter</el-button>
        <el-button @click="applyFilter" type="primary" >Apply Filter</el-button>
        
    </div>
</template>